const getSearchParams = ({ search_type }) => {

  return {
    // availability: 11, // Double check
    per_page: search_type === "map" ? 300 : 12,
    fields: [
      "id",
      "modified",
      "featured_media",
      "featured_media_url",
      "featured_media_url__medium_large",
      "featured_media_url__thumbnail",
      "title",
      "link",
      "availability",
      "feature",
      "coordinates",
      "listing_source",
      "listing_type",
      "property_name",
      "property_type",
      "tenure",
      "location",
      "price",
      "price_type",
      "bedrooms",
      "bathrooms",
      "floor_area",
      "floor_area_type",
      "land_area",
      "land_area_type",
      "has_videos",
      "has_socials",
      "has_virtual_tours",
      "has_floor_plans",
    ],
    order: {
      orderby_custom: [
        "post_modified"
      ],
      orderby_isnull_custom: [
        "0"
      ],
      order_custom: [
        "DESC"
      ],
      ordertype_custom: [
        "DATETIME"
      ]
    }
  }

}

const getSearchParamsHook = () => {

  const searchParamsHook = (params) => {

    let newParams = { ...params };
    if (params.property_name) {
      newParams["property_name[compare=LIKE]"] = params.property_name;
      delete newParams.property_name;
    }
    if (params.property_type) {
      const property_type = Array.isArray(params.property_type) ? params.property_type : [params.property_type];
      newParams["property_type[compare=REGEXP]"] = property_type.join("|");
      delete newParams.property_type;
    }
    if (params.location) {
      // Passthrough
    }
    if (params.tenure) {
      // Passthrough
    }
    if (params.bedroom > 0) {
      if (params.bedroom > 5) {
        newParams["bedroom[compare=BETWEEN][type=numeric]"] = [6,100];
        delete newParams.bedroom;
      }
      else {
        newParams["bedroom"] = params.bedroom;
      }
    }
    if (params.price_min > 0 || params.price_max >  0) {
      if (isNaN(params.price_min)) {
        params.price_min = 1; // << Do not set to 0
      }
      if (isNaN(params.price_max)) {
        params.price_max = 100*1e6;
      }
      newParams["price[compare=BETWEEN][type=NUMERIC]"] = [params.price_min.toString(), params.price_max.toString()];
      delete newParams.price_min;
      delete newParams.price_max;
    }
    return newParams;

  }

  return searchParamsHook;

}


const getSearchResultsHook = () => {

  const searchResultsHook = async (res) => {
    return res;
  }

  return searchResultsHook;

}

export { getSearchParams, getSearchParamsHook, getSearchResultsHook };
